"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartAutopilotJobRequestBody = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
// Used by both the frontend client and the backend server
exports.StartAutopilotJobRequestBody = zod_1.default.object({
    projectUid: zod_1.default.string(),
    threadUid: zod_1.default.string(),
    messageUid: zod_1.default.string(),
    userUid: zod_1.default.string(),
});
//# sourceMappingURL=api.js.map